import httpHubless from 'hub-http/clients/noPortalApiClient';
import Endpoints from '../constants/apiEndpoints';
import { setToken } from './authentication';
const getEndpointBody = precedence => {
  return {
    twoFactorLevel: precedence,
    clientType: 'HUBSPOT'
  };
};
const fetchTwoFactorMethod = precedence => new Promise((resolve, reject) => {
  httpHubless.post(Endpoints.TWO_FACTOR_CHALLENGE, {
    data: getEndpointBody(precedence)
  }).then(result => {
    if (typeof result !== 'object' || !result.method) resolve(null);
    setToken(result.token);
    resolve(Object.assign({}, result));
  }).catch(err => reject(err));
});
export default fetchTwoFactorMethod;